import React from 'react';
import { Box, useTheme, useMediaQuery, styled } from '@mui/material';
import clsx from 'clsx';

const drawerWidth = 300;

const StyledBox = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	transition: theme.transitions.create(['margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen
	}),
	marginLeft: drawerWidth,
	marginTop: theme.spacing(4),
	'&.shifted,': {
		transition: theme.transitions.create(['margin'], {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	[theme.breakpoints.down('md')]: {
		marginLeft: 0
	}
}));

const MainContent = styled(Box)(({ theme }) => ({
	flexGrow: 1,
	width: '100%',
	minHeight: '100vh',
	backgroundColor: theme.palette.background.default
}));

const Layout = ({ children, ...props }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<StyledBox className={[clsx({ shifted: isMobile }), ' bg-xrx ']}>
			<MainContent>{children}</MainContent>
		</StyledBox>
	);
};

export default Layout;
